<template>
    <app-layout>
        <template #header>
            <div class="relative flex justify-between items-center">
                <div>
                    <h2 class=" font-bold text-xl leading-tight">
                    <i class="fas fa-hand-holding-usd"></i>
                        Enviar
                    </h2>
                </div>
                <Balance :short="true"/>
            </div>
        </template>
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
            <section class="mx-4 xl:mx-32 lg:mx-20 md:mx-3 xl:mt-16 lg:mt-16 md:mt-6 sm:mt-6 mt-4">
                <Slider v-if="showSlider" :stages="sliderStages" />
                <div class="px-5">
                    <SelectKey
                        v-show="sections.selectKey"
                        :contacts="contacts"
                        :get-info-key="getInfoKey"
                        @back="$emit('back')"
                        @next="next"
                    />
                    <FormValueDetails
                        v-if="sections.valueDetails"
                        :favored="favored"
                        @go-back="goBack"
                        @next="submitPix"
                    />
                </div>
            </section>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "../../../Layouts/AppLayout.vue";
import SelectKey from "./SelectKey.vue";
import FormValueDetails from "./FormValueDetails.vue";
import Slider from "./../components/Slider.vue";
import Balance from "../../../Helpers/Balance.vue";

export default {
    name: "Pix",
    data: () => ({
        showSlider: true,
        sections: {
            selectKey: false,
            valueDetails: false,
        },
        contacts: {
            data: [],
            loading: false
        },
        favored: {
            chave: '76aa2d79-2872-4d8b-9b85-bd0f29d147c8',
            nomeCorrentista: 'Josimar Rocha',
            documentoFederal: '355.625.145-12',
            conta: {
                agencia: '1234'
            },
            banco: {
                descricao: 'BMP Money Plus',
                numero: '274'
            }
        }
    }),
    computed: {
        sliderStages(){
            return [{
                    titleStage: 'Modalidade de envio',
                    percentage: '0%',
                    selected: false,
                    completed: true
                },
                {
                    titleStage: 'Chave copia e cola',
                    percentage: '50%',
                    selected: this.sections.selectKey,
                    completed: this.sections.valueDetails,
                },
                {
                    titleStage: 'Valor e detalhes',
                    percentage: '98.7%',
                    selected: this.sections.valueDetails,
                    completed: this.sections.valueDetails,
                }]
        }
    },
    methods: {
        submitPix(){
            this.sections.valueDetails = false
            this.showSlider = false
        },
        next(){
            this.sections.selectKey = false
            this.sections.valueDetails = true
        },
        goBack(){
            this.sections.selectKey = true
            this.sections.valueDetails = false
        },
        async getInfoKey(key){
            try {
                const { data: dataCopyPaste } = await axios.get(`/json/pix/qrcode/read?emv=${key}`)
                if (dataCopyPaste.error)  return dataCopyPaste.error
                const { data: dataFavored } = await axios.get(`/json/pix/key/validate?key=${dataCopyPaste.chave}`)
                this.favored = { ...dataCopyPaste, ...dataFavored }
                this.next()
            } catch (error) {
                return 'Chave copia e cola inválida'
            }

        },
    },
    beforeMount() {
        setTimeout(() => (this.sections.selectKey = true), 0);
    },
    components: {
        AppLayout,
        SelectKey,
        FormValueDetails,
        Slider,
        Balance
    }
};
</script>
